import { QIcon_chevron_left } from '@repo/icons/index'
import { useActivity } from '@stackflow/react'
import classNames from 'classnames'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { COLORS } from '../../../../modules/vars'
// depth 1 (모아보기, overview 페이지) : NavBar 미노출
// depth 2~ (caf상세, 상상세, highlight) : NavBar 노출

/**
 * @param headerShown : 노출여부
 * @param handleClickBackBtn : 뒤로가기 버튼 클릭시 실행될 함수(history가 없는 경우 명시해줘야함) //
 */
interface INavBarProp {
  handleClickBackBtn?: () => void
  title?: string
  capitalize: boolean
  children?: any
}

const StackNavBar = ({ title, capitalize, children }: INavBarProp) => {
  /**
   * 상단 헤더 NavBar의 뒤로가기 버튼 클릭시 동작
   * 1. previous page history 있는 경우 : router.back()
   * 2. previous page history 없는 경우(처음 랜딩된경우) : Prop으로 커스텀하게 제어
   */
  return (
    <div className={styles.container(true)}>
      {
        <>
          <div className={styles.container2}>
            <div className={styles.titleCntr}>
              <h1 className={styles.title(capitalize)}>{title}</h1>
            </div>
          </div>
          {children}
        </>
      }
    </div>
  )
}

export const StackNavBarBackIcon = ({ pop }) => {
  const activity = useActivity()
  const { popBackToRingleApp } = useWebviewNavigation()
  const handleBack = () => {
    if (activity.isRoot) {
      popBackToRingleApp()
    } else {
      pop()
    }
  }

  return (
    <div className="top-[0px] left-[0px] z-[10] flex items-start pl-[12px]" onClick={handleBack}>
      <QIcon_chevron_left width={24} height={24} color={COLORS.BLACK} />
    </div>
  )
}

const styles = {
  container: (headerShown: boolean) =>
    classNames(`fixed top-0 left-0 right-0 z-[998] w-full bg-white`, headerShown ? `h-[86px] pb-[13px]` : null),
  container2: `mt-[34px] flex h-[52px] w-full flex-auto items-center justify-center bg-white px-[23px]`,
  titleCntr: `col mr-[10px] items-center justify-center bg-white text-center`,
  title: (capitalize: boolean) =>
    classNames(`pr-[8px] text-[18px] font-medium tracking-wide`, capitalize && ` capitalize`),
}
export default StackNavBar
